import React from "react";
import { Row, Col } from "react-bootstrap";
import { FiFileText, FiDollarSign, FiClock, FiCheckCircle, FiXCircle } from "react-icons/fi";

const SettlementMetrics = ({ metrics }) => {
  return (
    <Row className="g-3 mb-4 row-cols-1 row-cols-md-5">
      <Col>
        <div className="bma-metric-card h-100">
          <div className="bma-icon-circle"><FiFileText /></div>
          <div>
            <div className="bma-metric-lbl">Total Settlements</div>
            <div className="bma-metric-val">{metrics.total_settlements || 0}</div>
          </div>
        </div>
      </Col>

      <Col>
        <div className="bma-metric-card h-100">
          <div className="bma-icon-circle blue"><FiDollarSign /></div>
          <div>
            <div className="bma-metric-lbl">Total Initiated Amount</div>
            <div className="bma-metric-val">₹ {Number(metrics.total_amount || 0).toLocaleString("en-IN")}.00</div>
          </div>
        </div>
      </Col>

      <Col>
        <div className="bma-metric-card h-100">
          <div className="bma-icon-circle green"><FiClock /></div>
          <div>
            <div className="bma-metric-lbl">Initiated</div>
            <div className="bma-metric-val">{metrics.settlement_initiated || 0}</div>
          </div>
        </div>
      </Col>

      <Col>
        <div className="bma-metric-card h-100">
          <div className="bma-icon-circle"><FiCheckCircle /></div>
          <div>
            <div className="bma-metric-lbl">Completed</div>
            <div className="bma-metric-val">{metrics.settlement_completed || 0}</div>
          </div>
        </div>
      </Col>

      <Col>
        <div className="bma-metric-card h-100">
          <div className="bma-icon-circle" style={{ backgroundColor: "#7f1d1d", color: "#fca5a5" }}>
            <FiXCircle />
          </div>
          <div>
            <div className="bma-metric-lbl">Failed / Cancelled</div>
            <div className="bma-metric-val">{metrics.failed_cancelled || 0}</div>
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default SettlementMetrics;